var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2053_61700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 0.55001C5.23622 0.55001 0.549996 5.23623 0.549996 11C0.549997 16.7638 5.23622 21.45 11 21.45C16.7638 21.45 21.45 16.7638 21.45 11C21.45 5.23623 16.7638 0.550009 11 0.55001ZM11 19.4925C6.31378 19.4925 2.50756 15.6862 2.50756 11C2.50756 6.31379 6.31378 2.50757 11 2.50757C15.6862 2.50757 19.4924 6.31379 19.4924 11C19.4924 15.6862 15.6862 19.4925 11 19.4925Z",
    fill: "white",
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5343 6.04541C12.5343 7.65258 10.1242 7.65258 10.1242 6.04541C10.1242 4.43823 12.5343 4.43823 12.5343 6.04541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4748 8.89429L12.184 8.89429L12.184 17.2416L10.4748 17.2416L10.4748 8.89429Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2053_61700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(22 22) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.7d8ad984021a079c79d651c688766cf7.svg";
export { ForwardRef as ReactComponent };